<template>
  <div class="popup__msg">
    <slot />
  </div>
</template>
